export interface 利用者型 {
  医療機関コード: string;
  利用者コード: string;
  利用者氏名: string;
  パスワード: string;
  部署コード: string;
  部署名: string;
  権限レベル区分: string;
  開始日: Date;
  更新バージョン: number;
  削除フラグ: string;
}

export const 利用者初期値 = {
  医療機関コード: '',
  利用者コード: '',
  利用者氏名: '',
  パスワード: '',
  部署コード: '',
  部署名: '',
  権限レベル区分: '利用者',
  開始日: new Date(),
  更新バージョン: 0,
  削除フラグ: '未削除',
};

